/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import moment from 'moment-timezone';

import { HourSelected } from '../models/hour-selected.model';
import { DATE_TIME_FORMAT } from './date-picker.consts';

export const START_HOUR_PICKER_ID = 'startHourPicker';
export const END_HOUR_PICKER_ID = 'endHourPicker';
export const MINUTES_RANGE = ['00', '15', '30', '45'];

export const HOURS_RANGE = function rangeHours(): number[] {
  return Array.from(Array(24).keys());
};

export function getHourPickerPosition(flatpickerIndex: number): string {
  const flatpickrArr = document.getElementsByClassName('flatpickr-calendar');
  const flatpickr = flatpickrArr[flatpickrArr.length - 1 - flatpickerIndex];
  if (flatpickr && flatpickr.attributes[2]) {
    const fromTop =
      Number(
        window
          .getComputedStyle(flatpickr, null)
          .getPropertyValue('top')
          .replace('px', '')
      ) - window.scrollY;
    const fromLeft = window
      .getComputedStyle(flatpickr, null)
      .getPropertyValue('left');
    const setStyle =
      'top: ' + fromTop.toString() + 'px; left: ' + fromLeft + '; right: auto;';
    return setStyle;
  } else {
    return '';
  }
}

export function formatPreselectedDateWithHour(
  date: string,
  hourSelected: HourSelected
): string {
  const formattedPrevDate = moment(date, DATE_TIME_FORMAT);
  const dateWithHour = formattedPrevDate.set({
    h: hourSelected.hours,
    m: hourSelected.minutes,
  });
  return dateWithHour.format('DD/MM/YYYY HH:mm');
}
